module.exports = __webpack_public_path__ + "static/share-5a2c7c6896df276b4408f32f94939a31.png";